// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (max-width: 769px) {\n.image-holder-mobile {\n    width: 222px;\n    height: 100px;\n    margin-left: -61px;\n}\n.eventimagerapper {\n    width: 100px;\n    overflow: hidden;\n    float: left;\n    margin-right: 20px;\n    border-radius: 6px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
